export default __webpack_public_path__ + "app/assets/images/pandora_404_route.png";